import { v4 as uuidv4 } from "uuid";
export class GroupSaveModel {
    constructor() {
        this.groupId = uuidv4();
        this.teamId = uuidv4();
        this.totalMembers = null;
        this.totalTasks = null;
        this.completedTasks = null;
    }
}
export default class addGroup extends GroupSaveModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
